// extracted by mini-css-extract-plugin
var _1 = "SetProgressButton__button--aNy5h";
var _2 = "SetProgressButton__canvas--Wpx_P";
var _3 = "SetProgressButton__shadow--ZVQtQ";
export { _1 as "button", _2 as "canvas", _3 as "shadow" }
